module.exports = __webpack_public_path__ + "img/104.01c25ac1.svg";